import {
  API,
  BASE_URL_API_V1,
  axiosClient,
} from "../../../Constant/apiConstant";

export const getDNCListService = async (params) => {
  try {
    const res = await axiosClient.get(`${BASE_URL_API_V1}${API.V1.DNC}`, {
      params: params,
    });
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createDNCService = async (data) => {
  try {
    const res = await axiosClient.post(`${BASE_URL_API_V1}${API.V1.DNC}`, data);
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteDNCService = async (ids) => {
  try {
    const res = await axiosClient.delete(`${BASE_URL_API_V1}${API.V1.DNC}`, {
      params: { ids: ids },
    });
    return res?.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const editDNCService = async (data, id) => {
  try {
    let res = await axiosClient.put(`${BASE_URL_API_V1}${API.V1.DNC}`, data, {
      params: { id: id },
    });
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const saveDNCListExcelService = async (data) => {
  try {
    const res = await axiosClient.post(
      `${BASE_URL_API_V1}${API.V1.DNC}/excel`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
